// @ts-nocheck
import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const getContactByEmail = async (email: string) => {
  const response = await privateRequest.get(`${ConfEnv.API_CONTACT.GET_CONTACT}?email=${encodeURIComponent(email)}`);
  return response;
};

export const addContactService = async (contactID: string | number) => {
  return privateRequest.post(ConfEnv.API_CONTACT.ADD_CONTACT, {contact_id: contactID});
};

export const listMyContactsService = async () => {
  return privateRequest.get(ConfEnv.API_CONTACT.LIST_CONTACT);
};

export const updateContactService = async (data: Record<string, unknown>) => {
  return privateRequest.patch(ConfEnv.API_CONTACT.UPDATE_CONTACT, data);
};

export const deleteContactService = async (id: string | number) => {
  return privateRequest.delete(`${ConfEnv.API_CONTACT.DELETE_CONTACT}/${encodeURIComponent(id)}`);
};
